import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { BlogCard } from "@/components/blog-card";
import { ScrollReveal } from "@/components/scroll-reveal";
import type { BlogPost } from "@/lib/types";

interface BlogRecommendationsProps {
  posts: BlogPost[];
  title?: string;
  showViewMore?: boolean;
  maxPosts?: number;
  sectionId?: string;
}

export function BlogRecommendations({
  posts,
  title = "From the Blog",
  showViewMore = true,
  maxPosts = 3,
  sectionId = "related-articles",
}: BlogRecommendationsProps) {
  if (!posts || posts.length === 0) return null;

  const displayPosts = posts.slice(0, maxPosts);

  return (
    <section className="mb-12" id={sectionId}>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-serif font-semibold text-foreground">
          {title}
        </h2>
        {showViewMore && (
          <Link
            href="/blog"
            className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-accent hover:text-accent/80 transition-colors"
          >
            View more articles
            <ArrowRight className="h-4 w-4" />
          </Link>
        )}
      </div>
      <ScrollReveal className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {displayPosts.map((post) => (
          <BlogCard key={post.slug} post={post} />
        ))}
      </ScrollReveal>
      {showViewMore && (
        <div className="mt-6 text-center sm:hidden">
          <Link
            href="/blog"
            className="inline-flex items-center gap-2 text-sm font-medium text-accent hover:text-accent/80 transition-colors"
          >
            View more articles
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      )}
    </section>
  );
}
